(function () {
  'use strict';

  angular.module('ringbaPortal').component('dashboardOnboarding', {
    bindings: {},
    controller: DashboardOnboardingController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/dashboard/dashboard-onboarding.view.html'
  });

  function DashboardOnboardingController($state) {
    'ngInject';

    const vm = this;
    vm.$onInit = onInit;
    vm.goToWizard = goToWizard;

    function onInit(){
      vm.expanded = true;
    }

    function goToWizard(){
      $state.go('dashboard.campaign-wizard');
    }
  }
})();
